<template>
    <div>
        <div class='MMSWrap' v-if="file">
            <div v-if="type && imagesWeDisplay.indexOf(type) > -1" class='imageWrap'>
                <img :src="file" :width='width' :height='height' @error="fileRenderError = true">
            </div>

            <div v-else-if="type && type.indexOf('mpeg') > -1" class='videoWrap'>
                <video @click="$emit('video-player', file, 'video/mpeg')" no-controls  @error="fileRenderError = true">
                    <source :src="file" type="video/mpeg">
                </video>
                <i class="zmdi zmdi-play-circle" @click="$emit('video-player', file, 'video/mpeg')"></i>
            </div>

            <div v-else-if="type && type.indexOf('mp4') > -1" class='videoWrap'>
                <video @click="$emit('video-player', file, 'video/mp4')" no-controls  @error="fileRenderError = true">
                    <source :src="file" type="video/mp4">
                </video>
                <i class="zmdi zmdi-play-circle" @click="$emit('video-player', file, 'video/mp4')"></i>
            </div>

            <a v-else-if="type && videosWeDownload.indexOf(type) > -1" class='textFileHolder' :href="file" target="_blank">
                <i class="zmdi zmdi-collection-video"></i>
                <label class='sub'>Video: Click to View/Download</label>
            </a>

            <a v-else class='textFileHolder' :href="file" target="_blank">
                <i class="zmdi zmdi-download"></i>
                <label class='sub' v-if="file.indexOf('?') > -1">
                    Click to View/Download {{ file.substring(file.lastIndexOf('.') + 1, file.indexOf('?')) }}
                </label>
                <label class="sub" v-else>
                    Click to View/Download {{ file.substring(file.lastIndexOf('.') + 1, file.length) }}
                </label>
            </a>
        </div>

        <label class='sub loadError' v-if="file && fileRenderError">
            We apologize but this file could not be loaded.
        </label>
    </div>
</template>

<script>
export default {
    name: 'MultimediaSent',
    props: ['file', 'type', 'width', 'height'],
    data: function(){
        return {
            imagesWeDisplay: ['gif', 'jpg', 'png', 'jpeg', 'bmp'],
			videosWeDownload: ['3gp'],
            fileRenderError: false
        }
    }
}
</script>